"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _reducer = _interopRequireDefault(require("../../../components/page-header/reducer"));

var _reducer2 = _interopRequireDefault(require("../../../components/notification/reducer"));

var _reducer3 = _interopRequireDefault(require("../../../components/spinner-overlay/reducer"));

var _vaultReducer = require("../modules/secrets/vault-reducer");

var _secretsReducer = _interopRequireDefault(require("../modules/secrets/secrets-reducer"));

var _reducer4 = _interopRequireDefault(require("../../../components/policy/Members/reducer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rootReducer = (0, _redux.combineReducers)({
  pageHeader: _reducer.default,
  notification: _reducer2.default,
  spinnerOverlay: _reducer3.default,
  vaultLanding: _vaultReducer.vaultLanding,
  userSecretsReducer: _secretsReducer.default,
  membersReducer: _reducer4.default
});
var _default = rootReducer;
exports.default = _default;